import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _map from 'lodash/map';

import { AppContext } from 'commons-ui';

import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { Experiment } from '../../utils/types';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../utils/formConfig';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestEditExperiment } = useService();
	const data = hydrateFormData(_get(location, ['state', 'rowData']));
	const { testBuckets = [] } = data;
	const updateOptions = [
		...(data.controlBucket ? [{ id: data.controlBucket.name, label: data.controlBucket.name }] : []),
		...data.testBuckets.map((bucket) => ({ id: bucket.name, label: bucket.name }))
	];

	const controlShareDependencies = _map(testBuckets, (_, index) => `testBuckets[${index}].share`);

	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.CONTROL_BUCKET_SHARE].setRenderProps({ dependencies: controlShareDependencies });

	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.FROM].setRenderProps({ getOptions: async () => updateOptions });

	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.TO].setRenderProps({ getOptions: async () => updateOptions });

	const updateExperiment = (updatedData: { experimentData: Experiment }) => {
		setShowLoader(true);

		const { experimentData } = updatedData;

		requestEditExperiment(experimentData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while updating the experiment', { type: 'error' });
					setShowLoader(false);
					return;
				}

				showAlert('Experiment updated');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		updateExperiment(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
